import revive_payload_client_4sVQNw7RlN from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/builds/nht4944308/brands/afrimarkets/webapp/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/builds/nht4944308/brands/afrimarkets/webapp/.nuxt/pwa-icons-plugin.ts";
import pwa_client_Eorgdr12jA from "/builds/nht4944308/brands/afrimarkets/webapp/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import plugin_client_qU6eT5A32r from "/builds/nht4944308/brands/afrimarkets/webapp/modules/plugins/plugin.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_Eorgdr12jA,
  plugin_client_qU6eT5A32r
]